import React, { Component } from 'react';
import Button from '@mui/material/Button';
import FileDownload from '@mui/icons-material/Download';
import * as XLSX from "xlsx";

class DownloadButton extends Component {
  API_URL = process.env.REACT_APP_API_URL;

  handleClick = () => {
    const { resource } = this.props;
    const token = localStorage.getItem("token");
    fetch(`${this.API_URL}/${resource}/download`, {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((res) => res.text())
      .then((csvText) => {
        // Convertir CSV a array de objetos
        const rows = csvText.split("\n");
        const headers = rows[0].split(",");
        const data = rows.slice(1).map((row) => {
          const values = row.split(",");
          return headers.reduce((obj, header, i) => {
            obj[header.trim()] = values[i];
            return obj;
          }, {});
        });

        console.log("Pase por aqui");
        console.log(data);

        // Crear libro de Excel
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data);

        // Ajustar ancho de columnas
        const colWidths = headers.map((h) => ({
          wch: Math.max(h.length, 10),
        }));
        ws["!cols"] = colWidths;

        XLSX.utils.book_append_sheet(wb, ws, "Reporte");

        // Generar archivo y descargar
        XLSX.writeFile(
          wb,
          `${new Date().toISOString().split("T")[0]}-reporte.xlsx`
        );
      })
      .catch((e) => {
        console.error("Error al descargar:", e);
      });
  };

  render() {
    return (
      <Button
        variant="contained"
        onClick={this.handleClick}
        startIcon={<FileDownload />}
      >
        Descargar Excel
      </Button>
    );
  }
}

export default DownloadButton;